import {getWhatsAppTemplateByIdService} from '@/services/messageTemplatesService'
import {GetWhatsAppTemplateByIdResponse} from '@/types/WhatsappTemplate'
export type GetWhatsAppTemplateByIdUseCaseParams = {
  id: string
}
export async function getWhatsAppTemplateByIdUseCase(
  {id}: GetWhatsAppTemplateByIdUseCaseParams,
  signal?: AbortSignal
): Promise<GetWhatsAppTemplateByIdResponse> {
  return getWhatsAppTemplateByIdService(id, signal)
}
